var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"font-responsive xtype_subsection_header",attrs:{"id":_vm.component_data.id}},[_c('h2',{domProps:{"innerHTML":_vm._s(_vm.component_data.title)}})])}
var staticRenderFns = []

export { render, staticRenderFns }